import {callTargetedAction} from 'client/framework';
import questionTypeActions from 'components/QuestionTypes/questionType.actions';

export default function clearGuess(questionStoreName: string) {
  callTargetedAction({
    name: questionTypeActions.CLEAR_GUESS,
    targetStore: questionStoreName
  });
}
